import { render, staticRenderFns } from "./LimitCouponDemo.vue?vue&type=template&id=417df374&scoped=true&"
import script from "./LimitCouponDemo.vue?vue&type=script&lang=ts&"
export * from "./LimitCouponDemo.vue?vue&type=script&lang=ts&"
import style0 from "./LimitCouponDemo.vue?vue&type=style&index=0&id=417df374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417df374",
  null
  
)

export default component.exports